import styled from 'styled-components';
import { rem } from '@innovyze/stylovyze';

export const Heading = styled.div`
	color: #252f33;
	margin-bottom: ${rem(5)};
`;

export const Content = styled.div`
	color: ${({ theme }) => theme.palette.secondary.dark};
`;

export const Key = styled.div`
	background: rgba(217, 217, 217, 0.2);
	padding: ${rem(10)};
`;
